export class ErrorWithFriendlyMessage extends Error {
  friendlyMessage: string

  constructor(message: string, friendlyMessage: string) {
    super(message)
    this.friendlyMessage = friendlyMessage
  }
}
